export const PARKING_TYPE = {
  NORMAL: 'normal',
  MONTHLY: 'monthly',
} as const;

export const PARKING_TYPE_UPPERCASE = {
  NORMAL: 'NORMAL',
  MONTHLY: 'MONTHLY',
} as const;
